<template>
  <v-dialog
    v-if="category"
    :value="dialog"
    :hide-overlay="!dialog"
    @click:outside.stop="$emit('closed', true)"
    @keydown.esc="$emit('closed', true)"
    persistent
    max-width="500px"
    overlay-opacity="50"
    overlay-color="#ffffff"
    content-class="default-dialog"
    >
    <v-card>
      <v-card-title class="dialog-title">
        <span class="headline">
          {{ lang.confirm.title }}
        </span>
        <v-spacer></v-spacer>
        <v-icon class="dialog-close-btn" @click="$emit('closed', true)">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" class="pb-0">
              <p>{{ lang.categories.dialog.hasChildren(category.name) }}</p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="gray"
          text
          @click="$emit('closed', true)"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="$emit('choosed', { cat: category, reply: 1 })"
          :loading="get_interface.loading"
          :disabled="get_interface.loading"
        >
          Manter Sub-Categorias
        </v-btn>
        <v-btn
          color="red darken-1"
          text
          @click="$emit('choosed', { cat: category, reply: 2 })"
          :loading="get_interface.loading"
          :disabled="get_interface.loading"
        >
          Excluir Tudo
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ],
  props: {
    category: {
      type: Object,
      required: false
    },
    dialog: {
      type: Boolean,
      default: false
    }
  }
}
</script>
